import { AccountInterface } from "./Account";
import { CondimentInterface } from "./Condiment";
import { VIEW_TYPE } from "./Filter";
import { MixtureChooseEnum } from "./Mixture";

export interface MixCategoryInterface {
  name: string; 
  id: number;
  parentId?: number;
  active: boolean;
  order: number;
}

export interface MixTranslationInterface {
  name: string;
  description: string;
  languageId: number;
}

export interface MixInterface {
  id: number;
  name: string;
  description: string;
  image: string;
  account: AccountInterface;
  categories: MixCategoryInterface[];
  condiments: CondimentInterface[];
  categoryId: number;
  price: number;
  receipeType: MixtureChooseEnum;
  weight: number;
  parts: number;
  numberOfGlasses: number;
  meta: {
    selected: boolean;
  };
}

export interface MixState {
  isLoading: boolean;
  error: string | undefined;
  data: {
    mixes: MixInterface[] | [];
  };
}

export interface MixDetailsState {
  isLoading: boolean;
  error: string | undefined;
  data: MixInterface | null;
}

export interface MixWrapperProps {
  title: string;
  mixes: MixInterface[];
  view: VIEW_TYPE;
}

export interface MixCardProps {
  mix: MixInterface;
  view: VIEW_TYPE;
}

export enum MixSettingsJarFullness {
  EMPTY = "EMPTY",
  ONE_QUARTER = "ONE_QUARTER",
  HALF = "HALF",
  THREE_QUARTERS = "THREE_QUARTERS",
  FULL = "FULL",
}